import React from "react";
import { useRouteMatch } from "react-router";
import Login from "../pages/components/LandingHomePage/Login";
import SignUp from "../pages/components/LandingHomePage/SignUp";
import Container from "../components/Container";
import { useSelector } from "react-redux";
import { draPartnerId, partnerId } from "api/Consts";
import loginPage from "../assets/images/loginPage.png";

const LandingHomePage = () => {
  const { path } = useRouteMatch();
  const [notice] = useSelector(({ auth }) => [auth.signup_notice]);

  return (
    <Container className="z-1">
      <div
        className={`flex flex-col-reverse md:flex-row items-center justify-center ${
          draPartnerId === partnerId ? "2xl:min-h-screen" : "min-h-screen"
        }`}
      >
        {/* Welcome Section */}
        <div
          className={`w-full md:w-1/2 lg:w-2/3  ${
            draPartnerId === partnerId ? "" : "p-5 md:p-10"
          } bg-blue-50 md:bg-transparent text-center md:text-left`}
        >
          {partnerId !== draPartnerId ? (
            <div className="h-full p-4">
              <h1 className="text-2xl lg:text-3xl font-semibold my-4 text-japanese_indigo">
                Welcome to SkillsTrainer!
              </h1>
              <div
                className={`w-20 border-2 bg-${
                  partnerId || "default"
                }-primary h-0 my-6`}
              ></div>
              <h2 className="font-semibold text-xl">This Could Be You!</h2>
              {/* Images and Testimonials */}
              <div className="flex flex-col lg:flex-row my-3">
                {[
                  "testimonial-1.png",
                  "testimonial-2.png",
                  "testimonial-3.png",
                ].map((img, index) => (
                  <div
                    key={index}
                    className="bg-white flex flex-col p-2 rounded-md my-2 mx-2"
                  >
                    <img src={`./${img}`} className="rounded-md" alt={img} />
                    <div className="my-2">
                      <p className="text-sm">
                        Person {index + 1}, 20 yrs, Delhi Retail Trainee
                      </p>
                      <p className="text-sm">Associate @ Reliance Retail</p>
                      <p className="text-sm">
                        Income:{" "}
                        <span
                          className={`text-${partnerId || "default"}-primary`}
                        >
                          ₹15000+
                        </span>
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <div className="h-full p-5 bg-blue-50 rounded-lg">
              <h1 className="text-2xl lg:text-3xl font-semibold">
                Welcome to CSC-IIBF LMS!
              </h1>
              <img
                src={loginPage}
                className="rounded-md w-4/5 mt-4"
                alt="Login Page"
              />
              <p className="mt-4">
                To proceed, please use the credentials you received in your
                registered email.
              </p>
              <p className="mt-4">
                For login issues, contact Support{" "}
                <span className="text-blue-500 font-semibold">
                  cscdra@cscacademy.org(for DRA) and cscbc@cscacademy.org(for
                  BC) or 7011958630
                </span>
                <br />
                (Mon-Sat, 10AM - 5:30 PM).
              </p>
            </div>
          )}
        </div>
        {/* Input Fields Section (comes first on small screens) */}
        <div className="w-full md:w-1/2 xl:w-1/3 flex items-center mt-5 px-4 md:px-0">
          {draPartnerId === partnerId ? (
            path === "/signup" ? (
              <SignUp notice={notice} />
            ) : (
              <Login notice={notice} />
            )
          ) : path === "/login" ? (
            <Login notice={notice} />
          ) : (
            <SignUp notice={notice} />
          )}
        </div>
      </div>
    </Container>
  );
};

export default LandingHomePage;
